<input
  {{#if value}}value="{{value}}"{{/if}}
  {{#unless preview}}name="{{prefix}}[{{name}}]"{{/unless}}
  id="{{id}}"
  type="{{type}}"
  {{#if testIdPrefix}}data-testid="{{testIdPrefix}}-{{dasherize name}}"{{/if}}
  {{#if title }}title="{{title}}"{{/if}}
  {{#if onblur }}onblur="{{onblur}}"{{/if}}
  {{#if placeholder }}placeholder="{{placeholder}}"{{/if}}
  {{#if pattern }}pattern="{{pattern}}"{{/if}}
  {{#if maxlength }}maxlength="{{maxlength}}"{{/if}}
  {{#if class }}class="{{class}}"{{/if}}
  {{#if behaviour }}data-behaviour="{{behaviour}}"{{/if}}
  {{#if checked}}checked{{/if}}
  {{#if required}}required{{/if}}
  {{#if disabled}}disabled{{/if}}
  {{#if max_length }} maxlength="{{limit_size}}" {{/if}}
  {{{attributes}}}
/>
